 class CollectionUtils{
            // @ts-ignore
    groupBy<T extends any>(arr:Array<T>, field:string):Map<string,Array<T>>{
        const map = arr.reduce((map,elem)=>{
            // @ts-ignore
            if(!map.has(elem[field]))map.set(elem[field], [])
            // @ts-ignore
            map.get(elem[field])!.push(elem)
            return map
        }, new Map())
        return map
    }

    sumOf<T extends any>(arr:Array<T>, field:string, multiplier?:string):number{
        return  arr.reduce((sum,elem)=>{
            // @ts-ignore
            return multiplier!=null ?(elem[field])*(elem[multiplier])+sum : (elem[field])+sum
        }, 0)
    }

}

const collectionUtils = new CollectionUtils()
export default collectionUtils